import { render, staticRenderFns } from "./contrat.vue?vue&type=template&id=22d073d4"
import script from "./contrat.vue?vue&type=script&lang=ts"
export * from "./contrat.vue?vue&type=script&lang=ts"
import style0 from "./contrat.vue?vue&type=style&index=0&id=22d073d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports